import SvgIcon from 'vue-svgicon';
import requireContext from 'require-context.macro';
import './ui/icons/index.ts';
import './fonts/init.css';
import globalMixin from './mixins/frameworkGlobal';
import initDirectives from './utils/directives';

export default {
    install(Vue: any, options: object = {}) {
        Vue.use(SvgIcon, {
            tagName: 'Icon',
        });
        initDirectives(Vue);
        Vue.mixin(globalMixin);
        const requireComponent = requireContext('./ui', true, /[A-Z]\w+\.(vue|js)$/);
        requireComponent.keys().forEach(fileName => {
            const componentConfig = requireComponent(fileName);
            // @ts-ignore-next-line
            const componentName = fileName.split('/').pop().replace(/\.\w+$/, '');
            Vue.component(
                componentName,
                componentConfig.default || componentConfig
            );
        });
    },
};
